import { APIDecoratorWithBaseURI } from '../../Service/api'

export interface useValidationProps {
  fetcher: (data: useSiteUserValidateParams) => Promise<any>
}

interface useSiteUserValidateParams {
  identifier: string
  mode: string
}

export const useSiteUserValidate = (): useValidationProps => {
  const fetcher = async ({ identifier, mode }: useSiteUserValidateParams) => {
    return await APIDecoratorWithBaseURI().get(
      `producer/app/v2/user?identifier=${identifier}&mode=${mode}`
    )
  }

  return {
    fetcher,
  }
}
